<template>
  <v-sheet
    v-if="editedIndex != -1"
    class="mx-auto"
    elevation="8"
    max-width="1200"
  >
    <v-slide-group
      v-model="modelhojas"
      class="pa-4"
      selected-class="bg-success"
      show-arrows
    >
      <v-slide-group-item
        v-for="n in sheet"
        :key="n"
        v-slot="{ toggle, selectedClass }"
      >
        <v-card
          color="blue-lighten-4"
          :class="['ma-4', selectedClass]"
          height="70"
          width="140"
          @click="
            toggle();
            editItem(n);
          "
        >
          <v-card-item>
            <div>
              <div align="center" class="text-caption">
                <v-icon> {{ n.icono }} </v-icon>
              </div>
              <div align="center" class="text-caption">
                {{ n.descripcion }}
              </div>
            </div>
          </v-card-item>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </v-sheet>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-expansion-panels v-model="panel" multiple>
      <!--////////////////////////////////////////////// Identificación ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-information </v-icon>
            Identificación
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Matricula Inmobiliaria / Placa / Serial-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Ref1"
                label="Matrícula Inmobiliaria / Placa / Serial :"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :clearable="clearcampos.Ref1"
                :readonly="readcampos.Ref1"
              >
              </v-text-field>
            </v-col>
            <!--Chip-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Ref3"
                label="Chip :"
                hint="Digite Información"
                dense
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Cedula Catastral Corta-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Ref2"
                label="Cedula Catastral Corta :"
                hint="Digite Información"
                dense
                :rules="[
                  rules.requiredref2(editedItem.TipoActivoID, editedItem.Ref2),
                ]"
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Cedula Catastral Larga / ID-->
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.Ref4"
                label="Cedula Catastral Larga / ID :"
                hint="Digite Información"
                dense
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Datos principales para todos los activos ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title>
          <h2 align="center">
            <v-icon color="#B6332E" large>
              mdi-book-information-variant
            </v-icon>
            Datos principales
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Descripción -->
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="editedItem.Descripcion"
                label="Descripción del Activo :"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Tipo de Activo -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.TipoActivoID"
                :items="ArrayTipoActivo"
                :item-title="
                  (ArrayTipoActivo) =>
                    ArrayTipoActivo.ID + '-' + ArrayTipoActivo.Descripcion
                "
                item-value="ID"
                color="primary"
                label="Tipo de Activo:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo de Subactivo -->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.SubTipoActivoID"
                :items="ArraySubTipoActivo"
                :item-title="
                  (ArraySubTipoActivo) =>
                    ArraySubTipoActivo.ID + '-' + ArraySubTipoActivo.Descripcion
                "
                item-value="ID"
                color="primary"
                label="Tipo de Subactivo :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Sucursal -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.SucursalID"
                :items="ArraySucursalId"
                :item-title="
                  (ArraySucursalId) =>
                    ArraySucursalId.SucursalId +
                    '-' +
                    ArraySucursalId.Descripcion
                "
                item-value="SucursalId"
                color="primary"
                label="Sucursal:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Usabilidad-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.Usabilidad"
                :items="
                  ArrayUsabilidad.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayUsabilidad) =>
                    ArrayUsabilidad.Valor + '-' + ArrayUsabilidad.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Usabilidad :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Destinación-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.Destinacion"
                :items="
                  ArrayDestinacion.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor),
                  }))
                "
                :item-title="
                  (ArrayDestinacion) =>
                    ArrayDestinacion.Valor + '-' + ArrayDestinacion.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Destinación :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Moneda -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.MonedaID"
                :items="ArrayDesMoneda"
                :item-title="
                  (ArrayDesMoneda) =>
                    ArrayDesMoneda.CodMonedaId +
                    '-' +
                    ArrayDesMoneda.Sigla +
                    '-' +
                    ArrayDesMoneda.Descripcion
                "
                item-value="CodMonedaId"
                color="primary"
                label="Moneda :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Estado del Activo -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.EstadoActivo"
                :items="ArrayEstadoActivo"
                :item-title="
                  (ArrayEstadoActivo) =>
                    ArrayEstadoActivo.Valor +
                    '-' +
                    ArrayEstadoActivo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Estado del Activo :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Estado Juridico -->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.EstadoJuridico"
                :items="ArrayEstadoJuridico"
                :item-title="
                  (ArrayEstadoJuridico) =>
                    ArrayEstadoJuridico.Valor +
                    '-' +
                    ArrayEstadoJuridico.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Estado Jurídico :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha de Entrega Real del Activo-->
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.FechaRealEntrega"
                label="Fecha de Entrega Real del Activo:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Inicio Administración-->
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.FechaInicioAdministracion"
                label="Fecha Inicio Administración:"
                type="date"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Inicio Traspaso/Trasferencia-->
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="editedItem.FechaInicioTraspaso"
                label="Fecha Inicio Traspaso/Trasferencia:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Fin Traspaso/Trasferencia-->
            <v-col
              cols="12"
              sm="12"
              md="6"
              v-if="
                editedItem.FechaInicioTraspaso != null &&
                editedItem.FechaInicioTraspaso != '1810-01-01' &&
                editedItem.FechaInicioTraspaso != '1910-01-01'
              "
            >
              <v-text-field
                v-model="editedItem.FechaFinTraspaso"
                label="Fecha Fin Traspaso/Trasferencia:"
                type="date"
                :min="editedItem.FechaInicioTraspaso"
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Inventario - Propietario principal  del activo ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-clipboard-list </v-icon>
            Inventario - Propietario Principal del Activo
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Tipo de Documento Propietario-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.TypeDocumentIDRegistrado"
                :items="
                  ArrayTypeDocument_ID.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor), // 🔑 lo convertimos a número
                  }))
                "
                :item-title="
                  (ArrayTypeDocument_ID) =>
                    ArrayTypeDocument_ID.Valor +
                    '-' +
                    ArrayTypeDocument_ID.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Documento Propietario:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="ChangeTypeDocumentPropietario_ID()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Identificación Propietario-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.DocumentIDRegistrado"
                label="Documento propietario:"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                @change="ChangeDocumento_IDPropietario()"
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Nombre-->
            <v-col cols="12" sm="6" md="4">
              <span>Nombre: {{ editedItem.NombrePP }}</span>
            </v-col>
            <!--Observaciones de no Pertenencia-->
            <v-col cols="12" sm="6" md="12">
              <v-text-field
                v-model="editedItem.ObservacionesNoPertenencia"
                label="Observaciones de no Pertenencia:"
                hint="Digite Información"
                dense
                clearable
                maxlength="200"
                counter="200"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Ubicación del activo ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-map-marker </v-icon>
            Ubicación del Activo
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Departamento-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.DepartamentoID"
                :items="ArrayDpto_ID"
                :item-title="
                  (ArrayDpto_ID) =>
                    ArrayDpto_ID.DepartamentoId + '-' + ArrayDpto_ID.Nombre
                "
                item-value="DepartamentoId"
                color="primary"
                label="Departamento :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="ChangeDepto_ID()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Ciudad-->
            <v-col cols="12" sm="6" md="6">
              <v-autocomplete
                v-model="editedItem.CiudadID"
                :items="ArrayCiudadID"
                :item-title="
                  (ArrayCiudadID) =>
                    ArrayCiudadID.CiudadId + '-' + ArrayCiudadID.Nombre
                "
                item-value="CiudadId"
                color="primary"
                label="Ciudad:"
                dense
                clearable
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo de Documento Deudor-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.TypeDocumentIDU"
                :items="
                  ArrayTypeDocument_ID.map((x) => ({
                    ...x,
                    Valor: Number(x.Valor),
                  }))
                "
                :item-title="
                  (ArrayTypeDocument_ID) =>
                    ArrayTypeDocument_ID.Valor +
                    '-' +
                    ArrayTypeDocument_ID.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Documento Deudor:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="ChangeTypeDocument_ID()"
              >
              </v-autocomplete>
            </v-col>
            <!--Identificación Deudor-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.DocumentIDU"
                label="Identificación Deudor :"
                @change="ChangeDocumentIDU()"
                :update:modelValue="ChangeDocumentIDU()"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Nombre-->
            <v-col cols="12" sm="6" md="4">
              <span>Nombre: {{ editedItem.NombrePersona }}</span>
            </v-col>
            <!--Direccion Principal-->
            <v-col cols="12" sm="6" md="12">
              <v-autocomplete
                v-model="editedItem.DireccionU"
                :items="ArrayDireccion_Correspondencia"
                :item-title="
                  (ArrayDireccion_Correspondencia) =>
                    ArrayDireccion_Correspondencia.DireccionDetalle +
                    ' - ' +
                    ArrayDireccion_Correspondencia.ComplementoDireccion +
                    ' - ' +
                    ArrayDireccion_Correspondencia.NombreConjunto
                "
                item-value="DireccionID"
                color="primary"
                label="Dirección Pricipal:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Datos registro/Escrituración/Matricula ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-folder-home </v-icon>
            Datos Registro / Escrituración / Matrícula
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Notaria/Organismos de Tránsito-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.TypeDocumentIDNotaria"
                :items="ArrayNotaria"
                :item-title="
                  (ArrayNotaria) =>
                    ArrayNotaria.DocumentID + '-' + ArrayNotaria.Nombre
                "
                :item-value="
                  (ArrayNotaria) =>
                    ArrayNotaria.TypeDocumentID + '&' + ArrayNotaria.DocumentID
                "
                color="primary"
                label="Notaria/Organismos de Tránsito:"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo Escritura de Compra-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.TipoEscrituraCompra"
                :items="ArrayTipoEscCompra"
                :item-title="
                  (ArrayTipoEscCompra) =>
                    ArrayTipoEscCompra.Valor +
                    '-' +
                    ArrayTipoEscCompra.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo Escritura de Compra:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha Compra-->
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="editedItem.FechaEscrituraCompra"
                label="Fecha de Compra / Matrícula:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Datos contables ////////////////////////////////////////////////////////////-->
      <v-expansion-panel>
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-folder-pound </v-icon>
            Datos Contables
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Fecha Libros Contables-->
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="editedItem.FechaLibroContable"
                label="Fecha de Compra / Matrícula:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Inicia Vida Util-->
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                v-model="editedItem.FechaInicialVidaUtil"
                label="Fecha Inicia Vida Útil:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Unidad Vida Util-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.UnidadVidaUtil"
                :items="ArrayUniVidaUtil"
                :item-title="
                  (ArrayUniVidaUtil) =>
                    ArrayUniVidaUtil.Valor + '-' + ArrayUniVidaUtil.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Unidad Vida Útil :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Vida Util-->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="editedItem.VidaUtil"
                label="Vida Útil:"
                hint="Digite Información"
                dense
                clearable
                v-on:keypress="isNumber()"
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Valor Compra-->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="editedItem.ValorCompra"
                label="Valor Compra :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Comercial-->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="editedItem.ValorComercial"
                label="Valor Comercial :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Libros Contables-->
            <v-col cols="12" sm="6" md="3">
              <v-text-field
                v-model="editedItem.ValorLibro"
                label="Valor Libros Contables :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Caracteristicas inmuebles (solo para inmuebles) ////////////////////////////////////////////////////////////-->
      <v-expansion-panel v-if="editedItem.TipoActivoID == '1'">
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large> mdi-home-alert </v-icon>
            Características Inmuebles
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Clase Activo-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.ClaseActivo"
                :items="ArrayClaseAct"
                :item-title="
                  (ArrayClaseAct) =>
                    ArrayClaseAct.Valor + '-' + ArrayClaseAct.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Clase Activo :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Propiedad Horizontal-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.PropiedadHorizontal"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Propiedad Horizontal :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Objeto Social-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.ObjetoSocial"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Objeto Social :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Mayor Extención-->
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="editedItem.MayorExtension"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Mayor Extención :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="(editedItem.FechaDesenglobe = null)"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fecha de Desenglobe-->
            <v-col
              cols="12"
              sm="12"
              md="4"
              v-if="editedItem.MayorExtension == 'S'"
            >
              <v-text-field
                v-model="editedItem.FechaDesenglobe"
                label="Fecha Inicia Vida Útil:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Escritura Compra-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.EscrituraCompra"
                label="Escritura Compra:"
                hint="Digite Información"
                dense
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Escritura de Finalización-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.EscrituraFinalizacion"
                label="Escritura de Finalización:"
                hint="Digite Información"
                dense
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Propiedad -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajePropiedad"
                label="Porcentaje de Propiedad:"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Ocupación Arriendamiento -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajeArrendamiento"
                label="Porcentaje de Ocupación Arriendamiento :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Ocupación Comodato-->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajeComodato"
                label="Porcentaje de Ocupación Comodato :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Ocupación Invadido -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajeInvadido"
                label="Porcentaje de Ocupación Invadido :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Ocupación Desocupado -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajeDesocupado"
                label="Porcentaje de Ocupación Desocupado :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Porcentaje de Ocupación Uso Propio -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.PorcentajeUsoPropio"
                label="Porcentaje de Ocupación Uso Propio :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Consecutivo Cisa -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.ConsecutivoCisa"
                label="Consecutivo Cisa:"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="10"
                counter="10"
              >
              </v-text-field>
            </v-col>
            <!--Nombre Orip -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.NombreOrip"
                label="Nombre Orip:"
                hint="Digite Información"
                dense
                clearable
                maxlength="100"
                counter="100"
              >
              </v-text-field>
            </v-col>
            <!--Número de Predial 30 -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.NumeroPredial30"
                label="Número de Predial 30:"
                hint="Digite Información"
                dense
                clearable
                maxlength="100"
                counter="100"
              >
              </v-text-field>
            </v-col>
            <!-- Numero Predial 20 -->
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="editedItem.NumeroPredial20"
                label="Numero Predial 20:"
                hint="Digite Información"
                dense
                clearable
                maxlength="100"
                counter="100"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <!--////////////////////////////////////////////// Caracteristicas Vehiculos (solo para vehiculos) ////////////////////////////////////////////////////////////-->
      <v-expansion-panel
        v-if="
          editedItem.TipoActivoID == '2' ||
          editedItem.TipoActivoID == '3' ||
          editedItem.TipoActivoID == '4' ||
          editedItem.TipoActivoID == '5'
        "
      >
        <v-expansion-panel-title
          ><h2 align="center">
            <v-icon color="#B6332E" large>
              {{
                editedItem.TipoActivoID == "2"
                  ? "mdi-car-info"
                  : "mdi-robot-industrial"
              }}
            </v-icon>
            {{
              editedItem.TipoActivoID == "2"
                ? "Características vehículos"
                : editedItem.TipoActivoID == "3"
                ? "Características Maquinaria industrial"
                : editedItem.TipoActivoID == "4"
                ? "Características Maquinaria (Maquinaria Amarilla)"
                : "Características Maquinaria (Maquinaria Amarilla Autopropulsada) "
            }}
          </h2></v-expansion-panel-title
        >
        <v-expansion-panel-text>
          <v-row>
            <!--Fecha de Vencimiento-->
            <v-col
              cols="12"
              sm="12"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VFechaVencimiento"
                label="Fecha Inicia Vida Útil:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Matricula-->
            <v-col
              cols="12"
              sm="12"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VFechaMatricula"
                label="Fecha Matricula:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Fecha Expedición-->
            <v-col
              cols="12"
              sm="12"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VFechaExpLicencia"
                label="Fecha Expedición:"
                type="date"
                clearable
              ></v-text-field>
            </v-col>
            <!--Marca-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' ||
                editedItem.TipoActivoID == '4' ||
                editedItem.TipoActivoID == '5'
              "
            >
              <v-autocomplete
                v-model="editedItem.VMarca"
                :items="ArrayMarca"
                item-title="Marca"
                item-value="Marca"
                color="primary"
                label="Marca:"
                dense
                :rules="[
                  rules.requiredtype2(
                    editedItem.TipoActivoID,
                    editedItem.VMarca
                  ),
                ]"
                :update:modelValue="getFaseColdaID()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Fase Colda ID-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VFacecolda_ID"
                :items="ArrayFaseColdaID"
                :item-title="
                  (ArrayFaseColdaID) =>
                    ArrayFaseColdaID.Fasecolda_ID +
                    '-' +
                    ArrayFaseColdaID.Clase +
                    '-' +
                    ArrayFaseColdaID.Linea +
                    '-' +
                    ArrayFaseColdaID.Cilindraje
                "
                :item-value="
                  (ArrayFaseColdaID) =>
                    ArrayFaseColdaID.Fasecolda_ID +
                    '&' +
                    ArrayFaseColdaID.Clase +
                    '&' +
                    ArrayFaseColdaID.Linea +
                    '&' +
                    ArrayFaseColdaID.Cilindraje +
                    '&' +
                    ArrayFaseColdaID.Puertas +
                    '&' +
                    ArrayFaseColdaID.Combustible +
                    '&' +
                    ArrayFaseColdaID.Potencia +
                    '&' +
                    ArrayFaseColdaID.Servicio
                "
                color="primary"
                label="FaseColda ID :"
                dense
                :update:modelValue="ChangeFaseColda()"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Modelo-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' ||
                editedItem.TipoActivoID == '4' ||
                editedItem.TipoActivoID == '5'
              "
            >
              <v-autocomplete
                v-model="editedItem.VModelo"
                :items="ArrayModelo"
                color="primary"
                label="Modelo:"
                dense
                :rules="[
                  rules.requiredtype2(
                    editedItem.TipoActivoID,
                    editedItem.VModelo
                  ),
                ]"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Clase-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' ||
                editedItem.TipoActivoID == '4' ||
                editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VClase"
                label="Clase :"
                hint="Digite Información"
                dense
                :rules="[
                  rules.requiredtype2(
                    editedItem.TipoActivoID,
                    editedItem.VClase
                  ),
                ]"
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Linea-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' || editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VLinea"
                label="Línea :"
                hint="Digite Información"
                dense
                :rules="[
                  rules.requiredtype2(
                    editedItem.TipoActivoID,
                    editedItem.VLinea
                  ),
                ]"
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Cilindraje-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VCilindraje"
                label="Cilindraje :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Valor Compra Chasis-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorCompraChasis"
                label="Valor Compra Chasis :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Compra Carroceria-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorCompraCarroceria"
                label="Valor Compra Carroceria :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Comercial Accesorios-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorCompraAccesorios"
                label="Valor Comercial Accesorios :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Comercial Chasis-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorComercialChasis"
                label="Valor Comercial Chasis :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Comercial Carroceria-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorComercialCarroceria"
                label="Valor Comercial Carroceria :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Valor Comercial Accesorios-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VValorComercialAccesorios"
                label="Valor Comercial Accesorios :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="18"
                counter="18"
              >
              </v-text-field>
            </v-col>
            <!--Número de Motor-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VN_Motor"
                label="Número de Motor :"
                hint="Digite Información"
                dense
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Número de Chasis-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VN_Chasis"
                label="Número de Chasis :"
                hint="Digite Información"
                dense
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Número de Serie-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' ||
                editedItem.TipoActivoID == '4' ||
                editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VN_Serie"
                label="Número de Serie :"
                hint="Digite Información"
                dense
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Número de VIN-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' ||
                editedItem.TipoActivoID == '4' ||
                editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VN_VIN"
                label="Número de VIN :"
                hint="Digite Información"
                dense
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Combustible-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VCombustible"
                :items="ArrayCombustible"
                :item-title="
                  (ArrayCombustible) =>
                    ArrayCombustible.Valor + '-' + ArrayCombustible.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Combustible:"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--GPS-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VGPS"
                label="GPS :"
                hint="Digite Información"
                dense
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Número de Puertas-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VPuertas"
                label="Número de Puertas :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Potencia-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-text-field
                v-model="editedItem.VPotencia"
                label="Potencia :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Colores-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '2' || editedItem.TipoActivoID == '5'
              "
            >
              <v-autocomplete
                v-model="editedItem.VColores_ID"
                :items="ArrayColor"
                :item-title="
                  (ArrayColor) =>
                    ArrayColor.Valor + '-' + ArrayColor.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Colores :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Importación-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VImportacion"
                :items="ArrayImportacion"
                :item-title="
                  (ArrayImportacion) =>
                    ArrayImportacion.Valor + '-' + ArrayImportacion.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Importación :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo de Servicio-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VTipoServicio"
                :items="ArrayTipoServi"
                :item-title="
                  (ArrayTipoServi) =>
                    ArrayTipoServi.Valor + '-' + ArrayTipoServi.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Servicio :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Modalidad de Transporte-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VModalidadTrasporte"
                :items="ArrayModalidadTrans"
                :item-title="
                  (ArrayModalidadTrans) =>
                    ArrayModalidadTrans.Valor +
                    '-' +
                    ArrayModalidadTrans.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Modalidad de Transporte :"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Blindaje-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '2'"
            >
              <v-autocomplete
                v-model="editedItem.VBlindaje"
                :items="ArraySiNo"
                :item-title="
                  (ArraySiNo) => ArraySiNo.Valor + '-' + ArraySiNo.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Blindaje :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
                :update:modelValue="
                  ((editedItem.NombreBlindaje = null),
                  (editedItem.VN_TypeDocument_ID_Blind = null),
                  (editedItem.VN_Document_ID_Blind = null),
                  (editedItem.VNivelBlindaje = null))
                "
              >
              </v-autocomplete>
            </v-col>
            <!--Numero de pasajeros -->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.VModalidadTrasporte == '3' ||
                editedItem.VModalidadTrasporte == '2'
              "
            >
              <v-text-field
                v-model="editedItem.VN_Pasajeros"
                label="Numero de pasajeros :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="3"
                counter="3"
              >
              </v-text-field>
            </v-col>
            <!--Capacidad-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.VModalidadTrasporte == '3' ||
                editedItem.VModalidadTrasporte == '1'
              "
            >
              <v-text-field
                v-model="editedItem.VCapacidad"
                label="Capacidad :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Ficha de Homonologación-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.VModalidadTrasporte == '3' ||
                editedItem.VModalidadTrasporte == '1'
              "
            >
              <v-text-field
                v-model="editedItem.VFichadeHomologacion"
                label="Ficha de Homonologación :"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Peso Bruto-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.VModalidadTrasporte == '3' ||
                editedItem.VModalidadTrasporte == '1'
              "
            >
              <v-text-field
                v-model="editedItem.VPesoBrutoVehiculo"
                label="Peso Bruto :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="5"
                counter="5"
              >
              </v-text-field>
            </v-col>
            <!--Nivel de Blindaje-->
            <v-col cols="12" sm="6" md="6" v-if="editedItem.VBlindaje == 'S'">
              <v-autocomplete
                v-model="editedItem.VNivelBlindaje"
                :items="ArrayLvlModalidad"
                :item-title="
                  (ArrayLvlModalidad) =>
                    ArrayLvlModalidad.Valor +
                    '-' +
                    ArrayLvlModalidad.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Nivel de Blindaje :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <!--Tipo de documento Blindaje-->
            <v-col cols="12" sm="6" md="6" v-if="editedItem.VBlindaje == 'S'">
              <v-autocomplete
                v-model="editedItem.VN_TypeDocument_ID_Blind"
                :items="ArrayTypeDocument_ID"
                :item-title="
                  (ArrayTypeDocument_ID) =>
                    ArrayTypeDocument_ID.Valor +
                    '-' +
                    ArrayTypeDocument_ID.Descripcion
                "
                item-value="Valor"
                color="primary"
                label="Tipo de Documento :"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="ChangeTypeDocumentBlindaje_ID()"
              >
              </v-autocomplete>
            </v-col>
            <!--Identificación Blindaje-->
            <v-col cols="12" sm="6" md="6" v-if="editedItem.VBlindaje == 'S'">
              <v-text-field
                v-model="editedItem.VN_Document_ID_Blind"
                label="Documento Blindaje"
                @change="getNombrePBlindaje()"
                hint="Digite Información"
                dense
                :rules="[(v) => !!v || 'Campo obligatorio']"
                :update:modelValue="(editedItem.NombreBlindaje = null)"
                clearable
                maxlength="20"
                counter="20"
              >
              </v-text-field>
            </v-col>
            <!--Nombre-->
            <v-col cols="12" sm="6" md="6" v-if="editedItem.VBlindaje == 'S'">
              <span>Nombre: {{ editedItem.NombreBlindaje }}</span>
            </v-col>
            <!--Rodaje-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '5'"
            >
              <v-text-field
                v-model="editedItem.VRodaje"
                label="Rodaje :"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Motor-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '5'"
            >
              <v-text-field
                v-model="editedItem.VN_Motor"
                label="Motor :"
                hint="Digite Información"
                dense
                clearable
                maxlength="30"
                counter="30"
              >
              </v-text-field>
            </v-col>
            <!--Número de ID-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '5'"
            >
              <v-text-field
                v-model="editedItem.Ref5"
                label="Número de ID:"
                hint="Digite Información"
                dense
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Peso-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '5'"
            >
              <v-text-field
                v-model="editedItem.VPeso"
                label="Peso :"
                hint="Digite Información"
                dense
                clearable
                v-on:keypress="isNumber()"
                maxlength="16"
                counter="16"
              >
              </v-text-field>
            </v-col>
            <!--Tarjeta de Registro-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '4' || editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VTarjetaRegistro"
                label="Tarjeta de Registro :"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Número de Ejes-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '4'"
            >
              <v-text-field
                v-model="editedItem.VN_Ejes"
                label="Número de Ejes :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="6"
                counter="6"
              >
              </v-text-field>
            </v-col>
            <!--Número de Llantas-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '4'"
            >
              <v-text-field
                v-model="editedItem.VN_Llantas"
                label="Número de Llantas :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                :rules="[
                  rules.requiredtype2(
                    editedItem.TipoActivoID,
                    editedItem.VN_Llantas
                  ),
                ]"
                clearable
                maxlength="6"
                counter="6"
              >
              </v-text-field>
            </v-col>
            <!--Registro INVIMA -->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="editedItem.TipoActivoID == '3'"
            >
              <v-text-field
                v-model="editedItem.RegistroInvima"
                label="Registro INVIMA :"
                hint="Digite Información"
                dense
                clearable
                maxlength="50"
                counter="50"
              >
              </v-text-field>
            </v-col>
            <!--Referencia maquinaria-->
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                editedItem.TipoActivoID == '3' || editedItem.TipoActivoID == '4'
              "
            >
              <v-text-field
                v-model="editedItem.Ref5"
                label="Referencia :"
                hint="Digite Información"
                dense
                clearable
              >
              </v-text-field>
            </v-col>
            <!--Alto Total-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="
                editedItem.TipoActivoID == '4' || editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VAltoTotal"
                label="Alto Total :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="16"
                counter="16"
              >
              </v-text-field>
            </v-col>
            <!--Ancho Total-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="
                editedItem.TipoActivoID == '4' || editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VAnchoTotal"
                label="Ancho Total :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="16"
                counter="16"
              >
              </v-text-field>
            </v-col>
            <!--Largo Total-->
            <v-col
              cols="12"
              sm="6"
              md="4"
              v-if="
                editedItem.TipoActivoID == '4' || editedItem.TipoActivoID == '5'
              "
            >
              <v-text-field
                v-model="editedItem.VLargoTotal"
                label="Largo Total :"
                v-on:keypress="isNumber()"
                hint="Digite Información"
                dense
                clearable
                maxlength="16"
                counter="16"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "activos_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    llavesiframe: {
      type: Object,
      default: null,
      Description: "Información de llaves",
    },
    pageiframe: {
      type: Boolean,
      default: false,
      Description: "LLamado a Página Iframe",
    },
    componenteview: {
      type: Number,
      default: 0,
      Description: "Saber a que página llamar",
    },
    iconodialogbtn: {
      type: String,
      default: null,
      Description: "Información icono iframe",
    },
    titledialogbtn: {
      type: String,
      default: null,
      Description: "Información titulo iframe",
    },
    Exito: {
      type: String,
      default: null,
      Description: "Información de respuesta post o put",
    },
  },
  data() {
    return {
      panel: [0, 1, 2, 3, 4, 5],
      modelhojas: null,
      progreso: false,
      iconodialogbtn: "",
      titledialogbtn: "",
      componenteview: 0,
      buttonSave: false,
      sheet: [
        {
          icono: "mdi-account",
          descripcion: "Cliente",
          iconoelegido: 1,
        },
        {
          icono: "mdi-note",
          descripcion: "Contratos",
          iconoelegido: 2,
        },
        {
          icono: "mdi-account-lock",
          descripcion: "Seguros",
          iconoelegido: 3,
        },
        {
          icono: "mdi-home-modern",
          descripcion: "Avalúos",
          iconoelegido: 4,
        },
        {
          icono: "mdi-folder-open",
          descripcion: "Anexar Documento",
          iconoelegido: 5,
        },
        {
          icono: "mdi-file-search",
          descripcion: "Consulta documentos",
          iconoelegido: 6,
        },
      ],
      editedItem: {
        Ref1: null,
        Ref2: null,
        Ref3: null,
        Ref4: null,
        Ref5: null,
        Descripcion: null,
        ClaseActivo: null,
        PropiedadHorizontal: null,
        ObjetoSocial: null,
        ObservacionesNoPertenencia: null,
        PorcentajePropiedad: null,
        SecuenciaAvaluo: null,
        FechaLibroContable: null,
        ValorLibro: null,
        EstadoJuridico: null,
        NumeroProcesos: null,
        Proceso1: null,
        ObservacionProceso1: null,
        Proceso2: null,
        ObservacionProceso2: null,
        Proceso3: null,
        ObservacionProceso3: null,
        PorcentajeArrendamiento: null,
        PorcentajeComodato: null,
        PorcentajeInvadido: null,
        PorcentajeDesocupado: null,
        PorcentajeUsoPropio: null,
        TypeDocumentIDRegistrado: null,
        DocumentIDRegistrado: null,
        MayorExtension: null,
        FechaDesenglobe: null,
        TipoActivoID: null,
        SubTipoActivoID: null,
        TypeDocumentIDU: null,
        DocumentIDU: null,
        DireccionU: null,
        SucursalID: null,
        MonedaID: null,
        ValorCompra: null,
        ValorComercial: null,
        EstadoActivo: null,
        FechaRealEntrega: null,
        FechaInicioAdministracion: null,
        PaisID: "169",
        DepartamentoID: null,
        CiudadID: null,
        Usabilidad: null,
        Destinacion: null,
        FechaInicialVidaUtil: null,
        UnidadVidaUtil: null,
        VidaUtil: null,
        Estrato: null,
        TypeDocumentIDNotaria: null,
        DocumentIDNotaria: null,
        TipoEscrituraCompra: null,
        EscrituraCompra: null,
        FechaEscrituraCompra: null,
        EscrituraFinalizacion: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        FechaInicioTraspaso: null,
        FechaFinTraspaso: null,
        // Vehiculos
        VFechaMatricula: null,
        VFechaExpLicencia: null,
        VFechaVencimiento: null,
        VFacecolda_ID: null,
        VModelo: null,
        VClase: null,
        VMarca: null,
        VLinea: null,
        VCilindraje: null,
        VValorCompraChasis: null,
        VValorCompraCarroceria: null,
        VValorCompraAccesorios: null,
        VValorComercialChasis: null,
        VValorComercialCarroceria: null,
        VValorComercialAccesorios: null,
        VN_Motor: null,
        VN_Chasis: null,
        VN_Serie: null,
        VN_VIN: null,
        VCombustible: null,
        VColores_ID: null,
        VTipoCarroceria: null,
        VPuertas: null,
        VPotencia: null,
        VGPS: null,
        VImportacion: null,
        VDocumentoImportacion: null,
        VFechaImportacion: null,
        VTipoServicio: null,
        VN_TypeDocumentEmpAfiliadora: null,
        VN_DocumentEmpAfiliadora: null,
        VCupo: null,
        VModalidadTrasporte: null,
        VN_Pasajeros: null,
        VCapacidad: null,
        VFichadeHomologacion: null,
        VPesoBrutoVehiculo: null,
        VNumeroAprobacionMT: null,
        VNumeroTarjetaOperacion: null,
        VBlindaje: null,
        VNivelBlindaje: null,
        VN_TypeDocument_ID_Blind: null,
        VN_Document_ID_Blind: null,
        VIndicativo_Modificacion: null,
        VN_Llantas: null,
        VN_Ejes: null,
        VAnchoTotal: null,
        VLargoTotal: null,
        VAltoTotal: null,
        VPeso: null,
        VRodaje: null,
        VTarjetaRegistro: null,
        RegistroInvima: null,
        NombrePP: null,
        NombrePersona: null,
        NombreBlindaje: null,
      },
      defaultItem: {
        Ref1: null,
        Ref2: null,
        Ref3: null,
        Ref4: null,
        Ref5: null,
        Descripcion: null,
        ClaseActivo: null,
        PropiedadHorizontal: null,
        ObjetoSocial: null,
        ObservacionesNoPertenencia: null,
        PorcentajePropiedad: null,
        SecuenciaAvaluo: null,
        FechaLibroContable: null,
        ValorLibro: null,
        EstadoJuridico: null,
        NumeroProcesos: null,
        Proceso1: null,
        ObservacionProceso1: null,
        Proceso2: null,
        ObservacionProceso2: null,
        Proceso3: null,
        ObservacionProceso3: null,
        PorcentajeArrendamiento: null,
        PorcentajeComodato: null,
        PorcentajeInvadido: null,
        PorcentajeDesocupado: null,
        PorcentajeUsoPropio: null,
        TypeDocumentIDRegistrado: null,
        DocumentIDRegistrado: null,
        MayorExtension: null,
        FechaDesenglobe: null,
        TipoActivoID: null,
        SubTipoActivoID: null,
        TypeDocumentIDU: null,
        DocumentIDU: null,
        DireccionU: null,
        SucursalID: null,
        MonedaID: null,
        ValorCompra: null,
        ValorComercial: null,
        EstadoActivo: null,
        FechaRealEntrega: null,
        FechaInicioAdministracion: null,
        PaisID: "169",
        DepartamentoID: null,
        CiudadID: null,
        Usabilidad: null,
        Destinacion: null,
        FechaInicialVidaUtil: null,
        UnidadVidaUtil: null,
        VidaUtil: null,
        Estrato: null,
        TypeDocumentIDNotaria: null,
        DocumentIDNotaria: null,
        TipoEscrituraCompra: null,
        EscrituraCompra: null,
        FechaEscrituraCompra: null,
        EscrituraFinalizacion: null,
        SecuenciaCargue: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        FechaInicioTraspaso: null,
        FechaFinTraspaso: null,
        // Vehiculos
        VFechaMatricula: null,
        VFechaExpLicencia: null,
        VFechaVencimiento: null,
        VFacecolda_ID: null,
        VModelo: null,
        VClase: null,
        VMarca: null,
        VLinea: null,
        VCilindraje: null,
        VValorCompraChasis: null,
        VValorCompraCarroceria: null,
        VValorCompraAccesorios: null,
        VValorComercialChasis: null,
        VValorComercialCarroceria: null,
        VValorComercialAccesorios: null,
        VN_Motor: null,
        VN_Chasis: null,
        VN_Serie: null,
        VN_VIN: null,
        VCombustible: null,
        VColores_ID: null,
        VTipoCarroceria: null,
        VPuertas: null,
        VPotencia: null,
        VGPS: null,
        VImportacion: null,
        VDocumentoImportacion: null,
        VFechaImportacion: null,
        VTipoServicio: null,
        VN_TypeDocumentEmpAfiliadora: null,
        VN_DocumentEmpAfiliadora: null,
        VCupo: null,
        VModalidadTrasporte: null,
        VN_Pasajeros: null,
        VCapacidad: null,
        VFichadeHomologacion: null,
        VPesoBrutoVehiculo: null,
        VNumeroAprobacionMT: null,
        VNumeroTarjetaOperacion: null,
        VBlindaje: null,
        VNivelBlindaje: null,
        VN_TypeDocument_ID_Blind: null,
        VN_Document_ID_Blind: null,
        VIndicativo_Modificacion: null,
        VN_Llantas: null,
        VN_Ejes: null,
        VAnchoTotal: null,
        VLargoTotal: null,
        VAltoTotal: null,
        VPeso: null,
        VRodaje: null,
        VTarjetaRegistro: null,
        RegistroInvima: null,
        NombrePP: null,
        NombrePersona: null,
        NombreBlindaje: null,
      },
      rules: {
        requiredref2(TypeActivo, v) {
          if (TypeActivo == "1") {
            return !!v || "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
        requiredtype2(TypeActivo, v) {
          if (TypeActivo == "2") {
            return !!v || "Este campo es obligatorio.";
          } else {
            return true;
          }
        },
      },
      llaves: {
        TypeDocument_ID: null,
        Document_ID: null,
        Primer_Apellido: null,
        Segundo_Apellido: null,
        Primer_Nombre: null,
        Segundo_Nombre: null,
        Solicitud: null,
        Contrato: null,
        Ref1: null,
        Ref2: null,
        Ref3: null,
        IDServicio: null,
        IDPoliza: null,
        Secuencia_ID: null,
      },
      clearcampos: {
        Ref1: true,
      },
      readcampos: {
        Ref1: false,
      },
      ArrayTipoActivo: [],
      ArraySubTipoActivo: [],
      ArrayUsabilidad: [],
      ArrayDestinacion: [],
      ArrayEstadoActivo: [],
      ArrayEstadoJuridico: [],
      ArrayTypeDocument_ID: [],
      ArrayDesMoneda: [],
      ArraySucursalId: [],
      ArrayDpto_ID: [],
      ArrayCiudadID: [],
      ArrayDireccion_Correspondencia: [],
      ArrayTipoEscCompra: [],
      ArrayNotaria: [],
      ArrayUniVidaUtil: [],
      ArraySiNo: [],
      ArrayClaseAct: [],
      ArrayMarca: [],
      ArrayFaseColdaID: [],
      ArrayModelo: [],
      ArrayCombustible: [],
      ArrayColor: [],
      ArrayImportacion: [],
      ArrayTipoServi: [],
      ArrayModalidadTrans: [],
      ArrayLvlModalidad: [],
      wfasecolda: null,
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;
      if (
        // Todos
        this.editedItem.Ref1 == "" ||
        this.editedItem.Ref1 == null ||
        this.editedItem.Descripcion == "" ||
        this.editedItem.Descripcion == null ||
        this.editedItem.TipoActivoID == "" ||
        this.editedItem.TipoActivoID == null ||
        this.editedItem.SubTipoActivoID == "" ||
        this.editedItem.SubTipoActivoID == null ||
        this.editedItem.SucursalID == "" ||
        this.editedItem.SucursalID == null ||
        this.editedItem.Usabilidad == "" ||
        this.editedItem.Usabilidad == null ||
        this.editedItem.MonedaID == "" ||
        this.editedItem.MonedaID == null ||
        this.editedItem.EstadoActivo == "" ||
        this.editedItem.EstadoActivo == null ||
        this.editedItem.FechaInicioAdministracion == "" ||
        this.editedItem.FechaInicioAdministracion == null ||
        this.editedItem.TypeDocumentIDRegistrado == "" ||
        this.editedItem.TypeDocumentIDRegistrado == null ||
        this.editedItem.DocumentIDRegistrado == "" ||
        this.editedItem.DocumentIDRegistrado == null ||
        this.editedItem.TypeDocumentIDU == "" ||
        this.editedItem.TypeDocumentIDU == null ||
        this.editedItem.DocumentIDU == "" ||
        this.editedItem.DocumentIDU == null ||
        this.editedItem.DireccionU == "" ||
        this.editedItem.DireccionU == null ||
        this.editedItem.PaisID == "" ||
        this.editedItem.PaisID == null ||
        this.editedItem.DepartamentoID == "" ||
        this.editedItem.DepartamentoID == null ||
        this.editedItem.CiudadID == "" ||
        this.editedItem.CiudadID == null ||
        this.editedItem.TipoEscrituraCompra == "" ||
        this.editedItem.TipoEscrituraCompra == null ||
        this.editedItem.UnidadVidaUtil == "" ||
        this.editedItem.UnidadVidaUtil == null
      ) {
        validate = true;
      } else if (
        // Inmuebles
        this.editedItem.TipoActivoID == 1 &&
        (this.editedItem.Ref2 == "" || this.editedItem.Ref2 == null)
      ) {
        validate = true;
      } else if (
        // Vehiculos
        this.editedItem.TipoActivoID == 2 &&
        (this.editedItem.VModelo == "" ||
          this.editedItem.VModelo == null ||
          this.editedItem.VClase == "" ||
          this.editedItem.VClase == null ||
          this.editedItem.VMarca == "" ||
          this.editedItem.VMarca == null ||
          this.editedItem.VLinea == "" ||
          this.editedItem.VLinea == null ||
          this.editedItem.VCombustible == "" ||
          this.editedItem.VCombustible == null ||
          this.editedItem.VBlindaje == "" ||
          this.editedItem.VBlindaje == null)
      ) {
        validate = true;
      } else if (
        // Validar Persona Blindaje
        this.editedItem.VN_TypeDocument_ID_Blind != "" &&
        this.editedItem.VN_TypeDocument_ID_Blind != null &&
        this.editedItem.VN_Document_ID_Blind != "" &&
        this.editedItem.VN_Document_ID_Blind != null &&
        (this.editedItem.NombreBlindaje == "" ||
          this.editedItem.NombreBlindaje == null)
      ) {
        validate = true;
      } else if (
        // Validar Persona Activo
        this.editedItem.TypeDocumentIDU != "" &&
        this.editedItem.TypeDocumentIDU != null &&
        this.editedItem.DocumentIDU != "" &&
        this.editedItem.DocumentIDU != null &&
        (this.editedItem.NombrePersona == "" ||
          this.editedItem.NombrePersona == null)
      ) {
        validate = true;
      } else if (
        // Validar Persona Registrado
        this.editedItem.TypeDocumentIDRegistrado != "" &&
        this.editedItem.TypeDocumentIDRegistrado != null &&
        this.editedItem.DocumentIDRegistrado != "" &&
        this.editedItem.DocumentIDRegistrado != null &&
        (this.editedItem.NombrePP == "" || this.editedItem.NombrePP == null)
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        var NTR = [];
        if (
          this.editedItem.TypeDocumentIDNotaria != "" &&
          this.editedItem.TypeDocumentIDNotaria != null
        ) {
          NTR = this.editedItem.TypeDocumentIDNotaria.split("&");
          this.editedItem.TypeDocumentIDNotaria = NTR[0];
          this.editedItem.DocumentIDNotaria = NTR[1];
        }
        NTR = [];
        if (
          this.editedItem.VFacecolda_ID != "" &&
          this.editedItem.VFacecolda_ID != null
        ) {
          NTR = this.editedItem.VFacecolda_ID.split("&");
        }
        // Separar Información General de Vehiculos a Activos
        var vehiculos = {
          VRef1: this.editedItem.Ref1,
          VFechaMatricula: this.editedItem.VFechaMatricula,
          VFechaExpLicencia: this.editedItem.VFechaExpLicencia,
          VFechaVencimiento: this.editedItem.VFechaVencimiento,
          VFacecolda_ID: NTR.length == 0 ? 0 : NTR[0],
          VModelo: this.editedItem.VModelo,
          VClase: this.editedItem.VClase,
          VMarca: this.editedItem.VMarca,
          VLinea: this.editedItem.VLinea,
          VCilindraje: this.editedItem.VCilindraje,
          VValorCompraChasis: this.editedItem.VValorCompraChasis,
          VValorCompraCarroceria: this.editedItem.VValorCompraCarroceria,
          VValorCompraAccesorios: this.editedItem.VValorCompraAccesorios,
          VValorComercialChasis: this.editedItem.VValorComercialChasis,
          VValorComercialCarroceria: this.editedItem.VValorComercialCarroceria,
          VValorComercialAccesorios: this.editedItem.VValorComercialAccesorios,
          VN_Motor: this.editedItem.VN_Motor,
          VN_Chasis: this.editedItem.VN_Chasis,
          VN_Serie: this.editedItem.VN_Serie,
          VN_VIN: this.editedItem.VN_VIN,
          VCombustible: this.editedItem.VCombustible,
          VColores_ID: this.editedItem.VColores_ID,
          VTipoCarroceria: this.editedItem.VTipoCarroceria,
          VPuertas: this.editedItem.VPuertas,
          VPotencia: this.editedItem.VPotencia,
          VGPS: this.editedItem.VGPS,
          VImportacion: this.editedItem.VImportacion,
          VDocumentoImportacion: this.editedItem.VDocumentoImportacion,
          VFechaImportacion: this.editedItem.VFechaImportacion,
          VTipoServicio: this.editedItem.VTipoServicio,
          VN_TypeDocumentEmpAfiliadora:
            this.editedItem.VN_TypeDocumentEmpAfiliadora,
          VN_DocumentEmpAfiliadora: this.editedItem.VN_DocumentEmpAfiliadora,
          VCupo: this.editedItem.VCupo,
          VModalidadTrasporte: this.editedItem.VModalidadTrasporte,
          VN_Pasajeros: this.editedItem.VN_Pasajeros,
          VCapacidad: this.editedItem.VCapacidad,
          VFichadeHomologacion: this.editedItem.VFichadeHomologacion,
          VPesoBrutoVehiculo: this.editedItem.VPesoBrutoVehiculo,
          VNumeroAprobacionMT: this.editedItem.VNumeroAprobacionMT,
          VNumeroTarjetaOperacion: this.editedItem.VNumeroTarjetaOperacion,
          VBlindaje: this.editedItem.VBlindaje,
          VNivelBlindaje: this.editedItem.VNivelBlindaje,
          VN_TypeDocument_ID_Blind: this.editedItem.VN_TypeDocument_ID_Blind,
          VN_Document_ID_Blind: this.editedItem.VN_Document_ID_Blind,
          VIndicativo_Modificacion: this.editedItem.VIndicativo_Modificacion,
          VN_Llantas: this.editedItem.VN_Llantas,
          VN_Ejes: this.editedItem.VN_Ejes,
          VAnchoTotal: this.editedItem.VAnchoTotal,
          VLargoTotal: this.editedItem.VLargoTotal,
          VAltoTotal: this.editedItem.VAltoTotal,
          VPeso: this.editedItem.VPeso,
          VRodaje: this.editedItem.VRodaje,
          VTarjetaRegistro: this.editedItem.VTarjetaRegistro,
        };
        if (this.editedIndex != -1) {
          this.putRegistro(vehiculos);
        } else {
          this.postRegistro(vehiculos);
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro(Vehiculo) {
      this.progreso = true;
      var data = {
        Activos: this.editedItem,
        Vehiculos: null,
      };
      this.axios
        .post("/ActivosO/Activos/CR0/", data)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro(Vehiculo) {
      this.progreso = true;
      var data = {
        Activos: this.editedItem,
        Vehiculos: null,
      };
      this.axios
        .put("/ActivosO/Activos/UP0", data)
        .then((response) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Get para obtener nombre del Propietario
    async getNombrePropietario() {
      this.editedItem.NombrePP = null;
      if (
        this.editedItem.TypeDocumentIDRegistrado != "" &&
        this.editedItem.TypeDocumentIDRegistrado != null &&
        this.editedItem.DocumentIDRegistrado != "" &&
        this.editedItem.DocumentIDRegistrado != null
      ) {
        this.axios
          .get(
            "/Personas/Cliente/CD1/" +
              this.editedItem.TypeDocumentIDRegistrado +
              "/" +
              this.editedItem.DocumentIDRegistrado
          )
          .then((response) => {
            this.editedItem.NombrePP = response.data;
          })
          .catch((e) => console.log(e));
      }
    },
    // Get para obtener nombre del cliente
    async getNombreCliente() {
      this.editedItem.NombrePersona = null;
      if (
        this.editedItem.TypeDocumentIDU != "" &&
        this.editedItem.TypeDocumentIDU != null &&
        this.editedItem.DocumentIDU != "" &&
        this.editedItem.DocumentIDU != null
      ) {
        this.axios
          .get(
            "/Personas/Cliente/CD1/" +
              this.editedItem.TypeDocumentIDU +
              "/" +
              this.editedItem.DocumentIDU
          )
          .then((response) => {
            console.log(response);
            this.editedItem.NombrePersona = response.data;
          })
          .catch((e) => console.log(e));
      }
    },
    // Get para obtener nombre del Blindaje
    async getNombrePBlindaje() {
      this.editedItem.NombreBlindaje = "";
      if (
        this.editedItem.VN_TypeDocument_ID_Blind != "" &&
        this.editedItem.VN_TypeDocument_ID_Blind != null &&
        this.editedItem.VN_Document_ID_Blind != "" &&
        this.editedItem.VN_Document_ID_Blind != null
      ) {
        this.axios
          .get(
            "/Personas/Cliente/CD1/" +
              this.editedItem.VN_TypeDocument_ID_Blind +
              "/" +
              this.editedItem.VN_Document_ID_Blind
          )
          .then((response) => {
            if (!response.data[0].Error) {
              this.editedItem.NombreBlindaje = response.data[0].DescNombre;
            } else {
              this.editedItem.NombreBlindaje = "";
              this.$swal({
                icon: "warning",
                title: "Error al consultar datos",
                html: response.data[0].Mensaje,
              });
            }
          })
          .catch((e) => console.log(e));
      }
    },
    // Get para obtener direcciones
    async getDireccionPrincipal() {
      if (
        this.editedItem.TypeDocumentIDU != "" &&
        this.editedItem.TypeDocumentIDU != null &&
        this.editedItem.DocumentIDU != "" &&
        this.editedItem.DocumentIDU != null
      ) {
        this.axios
          .get(
            "/Personas/Direcciones/CD1/" +
              this.editedItem.TypeDocumentIDU +
              "/" +
              this.editedItem.DocumentIDU +
              "/"
          )
          .then((response) => {
            this.ArrayDireccion_Correspondencia = response.data;
          })
          .catch((e) => console.log(e));
      }
    },
    // Consulta Notaria
    async getNotaria() {
      this.ArrayNotaria = [];
      this.axios
        .get("/Personas/Cliente/CD2")
        .then((response) => {
          this.ArrayNotaria = response.data;
        })
        .catch((e) => console.log(e));
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.wfasecolda = null;
    },
    // Cargue Combos
    CargueCombos() {
      var TipoActivo = this.$store.getters.MTiposActivos;
      this.ArrayTipoActivo = TipoActivo.filter((item) => item.ID != 0);

      // Array Subtipo Activo
      TipoActivo = this.$store.getters.MSubTiposActivos;
      this.ArraySubTipoActivo = TipoActivo.filter((item) => item.ID != 0);

      // Array Usabilidad
      this.ArrayUsabilidad = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 11
      );

      // Arrray Destinación
      this.ArrayDestinacion = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 12
      );

      // Array Estado Activo
      this.ArrayEstadoActivo = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 8
      );

      // Array Estado Juridio
      this.ArrayEstadoJuridico = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 13
      );

      // Array Tipo Documento
      this.ArrayTypeDocument_ID = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 2
      );

      // Array Sucursal
      var Sucursal = this.$store.getters.MDescSucursal;
      this.ArraySucursalId = Sucursal.filter((item) => item.Sucursal != 0);

      // Array Moneda
      var Moneda = this.$store.getters.MDescMoneda;
      this.ArrayDesMoneda = Moneda.filter((item) => item.CodMonedaID != 0);

      // Tipo escritura Compra
      this.ArrayTipoEscCompra = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 14
      );

      // Array Unidad Vida Util
      this.ArrayUniVidaUtil = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 15
      );

      // Array si o no
      this.ArraySiNo = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 16
      );

      // Array Clase de Activo
      this.ArrayClaseAct = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 17
      );
      this.ChangePaisID();

      // Notaria
      this.getNotaria();
      //this.getModelo();
      // Vehiculos
      this.ArrayMarca = this.$store.getters.MFaseColda;

      // Array Combustible
      this.ArrayCombustible = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 18
      );

      // Array Color
      this.ArrayColor = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 19
      );

      // Array Importacion
      this.ArrayImportacion = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 20
      );

      // Array Tipo Servicio
      this.ArrayTipoServi = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 21
      );

      // Array Modalidad Trans
      this.ArrayModalidadTrans = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 22
      );

      // Array Nivel Modalidad
      this.ArrayLvlModalidad = this.$store.getters.MTablaSeleccion.filter(
        (item) => item.Valor != null && item.TablaId == 23
      );
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
        if (
          this.editedItem.TipoActivoID == 2 ||
          this.editedItem.TipoActivoID == 4 ||
          this.editedItem.TipoActivoID == 5
        ) {
          this.editedItem.VFechaMatricula =
            this.infoedit.InfoVeh.VFechaMatricula;
          this.editedItem.VFechaExpLicencia =
            this.infoedit.InfoVeh.VFechaExpLicencia;
          this.editedItem.VFechaExpLicencia =
            this.infoedit.InfoVeh.VFechaExpLicencia;
          this.editedItem.VFechaVencimiento =
            this.infoedit.InfoVeh.VFechaVencimiento;
          this.editedItem.VMarca = this.infoedit.InfoVeh.VMarca;
          if (
            this.infoedit.InfoVeh.VFacecolda_ID != 0 &&
            this.infoedit.InfoVeh.VFacecolda_ID != null
          ) {
            var FaseColda = this.$store.getters.MFaseColda;
            FaseColda = FaseColda.filter(
              (item) => item.Marca == this.editedItem.VMarca
            );
            if (FaseColda.length != 0) {
              FaseColda = FaseColda[0].InfoFaseColda.filter(
                (item) =>
                  item.Fasecolda_ID == this.infoedit.InfoVeh.VFacecolda_ID
              );
              FaseColda = FaseColda[0];
              this.editedItem.VFacecolda_ID =
                FaseColda.Fasecolda_ID +
                "&" +
                FaseColda.Clase +
                "&" +
                FaseColda.Linea +
                "&" +
                FaseColda.Cilindraje +
                "&" +
                FaseColda.Puertas +
                "&" +
                FaseColda.Combustible +
                "&" +
                FaseColda.Potencia +
                "&" +
                FaseColda.Servicio;
            }
          } else {
            this.editedItem.VFacecolda_ID = null;
          }
          this.editedItem.VModelo = this.infoedit.InfoVeh.VModelo;
          this.editedItem.VClase = this.infoedit.InfoVeh.VClase;
          this.editedItem.VLinea = this.infoedit.InfoVeh.VLinea;
          this.editedItem.VCilindraje = this.infoedit.InfoVeh.VCilindraje;
          this.editedItem.VValorCompraChasis =
            this.infoedit.InfoVeh.VValorCompraChasis;
          this.editedItem.VValorCompraCarroceria =
            this.infoedit.InfoVeh.VValorCompraCarroceria;
          this.editedItem.VValorCompraAccesorios =
            this.infoedit.InfoVeh.VValorCompraAccesorios;
          this.editedItem.VValorComercialChasis =
            this.infoedit.InfoVeh.VValorComercialChasis;
          this.editedItem.VValorComercialCarroceria =
            this.infoedit.InfoVeh.VValorComercialCarroceria;
          this.editedItem.VValorComercialAccesorios =
            this.infoedit.InfoVeh.VValorComercialAccesorios;
          this.editedItem.VN_Motor = this.infoedit.InfoVeh.VN_Motor;
          this.editedItem.VN_Chasis = this.infoedit.InfoVeh.VN_Chasis;
          this.editedItem.VN_Serie = this.infoedit.InfoVeh.VN_Serie;
          this.editedItem.VN_VIN = this.infoedit.InfoVeh.VN_VIN;
          this.editedItem.VCombustible = this.infoedit.InfoVeh.VCombustible;
          this.editedItem.VColores_ID = this.infoedit.InfoVeh.VColores_ID;
          this.editedItem.VTipoCarroceria =
            this.infoedit.InfoVeh.VTipoCarroceria;
          this.editedItem.VPuertas = this.infoedit.InfoVeh.VPuertas;
          this.editedItem.VPotencia = this.infoedit.InfoVeh.VPotencia;
          this.editedItem.VGPS = this.infoedit.InfoVeh.VGPS;
          this.editedItem.VImportacion = this.infoedit.InfoVeh.VImportacion;
          this.editedItem.VDocumentoImportacion =
            this.infoedit.InfoVeh.VDocumentoImportacion;
          this.editedItem.VFechaImportacion =
            this.infoedit.InfoVeh.VFechaImportacion;
          this.editedItem.VTipoServicio = this.infoedit.InfoVeh.VTipoServicio;
          this.editedItem.VN_TypeDocumentEmpAfiliadora =
            this.infoedit.InfoVeh.VN_TypeDocumentEmpAfiliadora;
          this.editedItem.VN_DocumentEmpAfiliadora =
            this.infoedit.InfoVeh.VN_DocumentEmpAfiliadora;
          this.editedItem.VCupo = this.infoedit.InfoVeh.VCupo;
          this.editedItem.VModalidadTrasporte =
            this.infoedit.InfoVeh.VModalidadTrasporte;
          this.editedItem.VN_Pasajeros = this.infoedit.InfoVeh.VN_Pasajeros;
          this.editedItem.VCapacidad = this.infoedit.InfoVeh.VCapacidad;
          this.editedItem.VFichadeHomologacion =
            this.infoedit.InfoVeh.VFichadeHomologacion;
          this.editedItem.VPesoBrutoVehiculo =
            this.infoedit.InfoVeh.VPesoBrutoVehiculo;
          this.editedItem.VNumeroAprobacionMT =
            this.infoedit.InfoVeh.VNumeroAprobacionMT;
          this.editedItem.VNumeroTarjetaOperacion =
            this.infoedit.InfoVeh.VNumeroTarjetaOperacion;
          this.editedItem.VBlindaje = this.infoedit.InfoVeh.VBlindaje;
          this.editedItem.VNivelBlindaje = this.infoedit.InfoVeh.VNivelBlindaje;
          this.editedItem.VN_TypeDocument_ID_Blind =
            this.infoedit.InfoVeh.VN_TypeDocument_ID_Blind;
          this.editedItem.VN_Document_ID_Blind =
            this.infoedit.InfoVeh.VN_Document_ID_Blind;
          this.editedItem.VIndicativo_Modificacion =
            this.infoedit.InfoVeh.VIndicativo_Modificacion;
          this.editedItem.VN_Llantas = this.infoedit.InfoVeh.VN_Llantas;
          this.editedItem.VN_Ejes = this.infoedit.InfoVeh.VN_Ejes;
          this.editedItem.VAnchoTotal = this.infoedit.InfoVeh.VAnchoTotal;
          this.editedItem.VLargoTotal = this.infoedit.InfoVeh.VLargoTotal;
          this.editedItem.VAltoTotal = this.infoedit.InfoVeh.VAltoTotal;
          this.editedItem.VPeso = this.infoedit.InfoVeh.VPeso;
          this.editedItem.VRodaje = this.infoedit.InfoVeh.VRodaje;
          this.editedItem.VTarjetaRegistro =
            this.infoedit.InfoVeh.VTarjetaRegistro;
          this.getNombrePBlindaje();
        }
        this.clearcampos.Ref1 = false;
        this.readcampos.Ref1 = true;
      } else {
        this.clearcampos.Ref1 = true;
        this.readcampos.Ref1 = false;
      }
      if (
        this.editedItem.TypeDocumentIDNotaria != null &&
        this.editedItem.TypeDocumentIDNotaria != 0 &&
        this.editedItem.DocumentIDNotaria != null &&
        this.editedItem.DocumentIDNotaria != ""
      ) {
        this.editedItem.TypeDocumentIDNotaria =
          this.editedItem.TypeDocumentIDNotaria +
          "&" +
          this.editedItem.DocumentIDNotaria;
      } else {
        this.editedItem.TypeDocumentIDNotaria = null;
      }
      this.getNombrePropietario();
      this.ChangeDocumentIDU();
      this.ChangeDepto_ID();
    },
    ///////////////////////////////////////////////// Cambios de campos ///////////////////////////////////////////
    // Item editar
    editItem(item) {
      var data = true;
      this.$emit("update:componenteview", item.iconoelegido);
      this.$emit("update:iconodialogbtn", item.icono);
      this.$emit("update:titledialogbtn", item.descripcion);
      this.$emit("update:pageiframe", data);
      switch (item.iconoelegido) {
        case 1: //Clientes
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentIDU;
          this.llaves.Document_ID = this.editedItem.DocumentIDU;
          break;
        case 2: //Contrato
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentIDU;
          this.llaves.Document_ID = this.editedItem.DocumentIDU;
          break;
        case 3: //Seguros
          this.llaves.TypeDocument_ID = this.editedItem.TypeDocumentIDU;
          this.llaves.Document_ID = this.editedItem.DocumentIDU;
          this.llaves.Ref1 = this.editedItem.Ref1;
          break;
      }
      this.$emit("update:llavesiframe", this.llaves);
    },
    // Change Documento Propietario
    ChangeDocumento_IDPropietario() {
      if (
        this.editedItem.DocumentIDRegistrado == "" ||
        this.editedItem.DocumentIDRegistrado == null
      ) {
        this.NombrePP = null;
      } else {
        this.getNombrePropietario();
      }
    },

    // Change Tipo de Documento Porpietario
    ChangeDocumentIDU() {
      if (
        this.editedItem.DocumentIDU == "" ||
        this.editedItem.DocumentIDU == null
      ) {
        this.ArrayDireccion_Correspondencia = [];
        this.editedItem.DireccionU = null;
        this.editedItem.NombrePersona = null;
      } else {
        this.getNombreCliente();
        this.getDireccionPrincipal();
      }
    },
    // Change Tipo de Documento Persona
    ChangeTypeDocument_ID() {
      if (
        this.editedItem.TypeDocumentIDU == "" ||
        this.editedItem.TypeDocumentIDU == null
      ) {
        this.editedItem.DocumentIDU = null;
        this.editedItem.NombrePersona = null;
        this.ArrayDireccion_Correspondencia = [];
        this.editedItem.DireccionU = null;
      }
    },
    // Change Tipo de Documento Porpietario
    ChangeTypeDocumentPropietario_ID() {
      if (
        this.editedItem.TypeDocumentIDRegistrado == "" ||
        this.editedItem.TypeDocumentIDRegistrado == null
      ) {
        this.editedItem.DocumentIDRegistrado = null;
        this.editedItem.NombrePP = null;
      }
    },
    // Change Tipo de Documento Blindaje
    ChangeTypeDocumentBlindaje_ID() {
      if (
        this.editedItem.VN_TypeDocument_ID_Blind == "" ||
        this.editedItem.VN_TypeDocument_ID_Blind == null
      ) {
        this.editedItem.VN_Document_ID_Blind = null;
        this.editedItem.NombreBlindaje = null;
      }
    },
    // Función de gestion cambio
    ChangePaisID() {
      this.ArrayDpto_ID = [];
      this.editedItem.DepartamentoID = null;
      this.getDpto_ID();
    },
    // Get para obtener array de los departamento existentes
    getDpto_ID() {
      console.log("Entro a departamento");
      if (this.editedItem.PaisID == "169") {
        this.ArrayDpto_ID = [];
        var ArrayDpto_ID2 = this.$store.getters.MDpto;
        console.log(ArrayDpto_ID2);
        this.ArrayDpto_ID = ArrayDpto_ID2.filter(
          (item) => item.DepartamentoId != 0
        );
      }
    },
    // Función de gestion cambio
    ChangeDepto_ID() {
      if (
        this.editedItem.DepartamentoID == "" ||
        this.editedItem.DepartamentoID == null
      ) {
        this.ArrayCiudadID = [];
        this.editedItem.CiudadID = null;
      } else {
        this.getCiudadID();
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudadID() {
      if (
        this.editedItem.DepartamentoID != "" &&
        this.editedItem.DepartamentoID != null
      ) {
        this.ArrayCiudadID = [];
        var Dpto = this.editedItem.DepartamentoID;

        var ArrayCiudad_ID2 = this.$store.getters.MCity;
        this.ArrayCiudadID = ArrayCiudad_ID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto
        );
      }
    },
    // Get para obtener Fasecolda
    getFaseColdaID() {
      this.ArrayFaseColdaID = [];
      if (this.editedItem.VMarca != null && this.editedItem.VMarca != "") {
        var FaseColda = this.$store.getters.MFaseColda;
        FaseColda = FaseColda.filter(
          (item) => item.Marca == this.editedItem.VMarca
        );
        if (FaseColda.length != 0) {
          this.ArrayFaseColdaID = FaseColda[0].InfoFaseColda;
        }
      }
    },
    // Change faceColda
    ChangeFaseColda() {
      var NTR = [];
      if (this.wfasecolda != this.editedItem.VFacecolda_ID) {
        this.wfasecolda = this.editedItem.VFacecolda_ID;
        if (
          this.editedItem.VFacecolda_ID != "" &&
          this.editedItem.VFacecolda_ID != null
        ) {
          NTR = this.editedItem.VFacecolda_ID.split("&");
          this.editedItem.VLinea = NTR[2];
          this.editedItem.VClase = NTR[1];
          this.editedItem.VCilindraje = NTR[3];
          this.editedItem.VPuertas = NTR[4];
          this.editedItem.VCombustible = NTR[5];
          this.editedItem.VPotencia = NTR[6];
          this.editedItem.VTipoServicio = NTR[7];
        }
      }
    },
    // Get para obtener array de modelo
    getModelo() {
      var FechaFinAnio =
        this.$store.getters.userperfil.userInfo.FechasCierre.FechaFinAnio;
      var dateSplit = FechaFinAnio.split("-");
      var year = parseInt(dateSplit[0]);
      this.ArrayModelo = [];
      for (var i = 0; i < 60; i++) {
        this.ArrayModelo.push(year);
        year--;
      }
    },
  },
  mounted() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
